var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "stretched policy-container" },
    [
      _c("div", { attrs: { id: "wrapper" } }, [
        _c(
          "div",
          {
            class:
              "container " +
              (_vm.$vuetify.breakpoint.xsOnly ? "pt-4 px-4 mb-2" : "pt-3 mb-6"),
          },
          [
            _c(
              "div",
              { staticClass: "d-inline-flex w-100 justify-content-start" },
              [
                _c(
                  "div",
                  { staticClass: "d-inline-flex w-50 align-items-center" },
                  [
                    _c(
                      "router-link",
                      { staticClass: "policy-back-link", attrs: { to: "/" } },
                      [
                        _c("img", {
                          attrs: {
                            src: "/content/svgs/arrow-back.svg",
                            alt: "back",
                          },
                        }),
                      ]
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "w-50 d-flex justify-content-end",
                    attrs: { id: "logo" },
                  },
                  [
                    _c("router-link", { attrs: { to: "/" } }, [
                      _c("img", {
                        staticClass: "logo-default",
                        attrs: {
                          srcset: "/content/images/stemdo-black-logo.png",
                          src: "/content/images/stemdo-black-logo.png",
                          alt: "Stemdo Logo",
                        },
                      }),
                    ]),
                  ],
                  1
                ),
              ]
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "section",
          {
            class: _vm.$vuetify.breakpoint.xsOnly ? "px-3" : "",
            attrs: { id: "content" },
          },
          [_vm._m(0)]
        ),
        _vm._v(" "),
        _c("footer", { attrs: { id: "footer" } }, [
          _c("div", { attrs: { id: "copyrights" } }, [
            _c("div", { staticClass: "container" }, [
              _c("div", { staticClass: "row" }, [
                _vm._m(1),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-md-7 text-center copyright-links" },
                  [
                    _c(
                      "div",
                      { staticClass: "d-flex justify-content-around px-2" },
                      [
                        _c("router-link", { attrs: { to: "/privacy" } }, [
                          _c("u", [_vm._v("Política de privacidad")]),
                        ]),
                        _vm._v(" "),
                        _c("router-link", { attrs: { to: "/cookies" } }, [
                          _c("u", [_vm._v("Política de Cookies")]),
                        ]),
                        _vm._v(" "),
                        _c("router-link", { attrs: { to: "/legal" } }, [
                          _c("u", [_vm._v("Aviso Legal")]),
                        ]),
                        _vm._v(" "),
                        _c("router-link", { attrs: { to: "/contact" } }, [
                          _c("u", [_vm._v("Contacto")]),
                        ]),
                      ],
                      1
                    ),
                  ]
                ),
                _vm._v(" "),
                _vm._m(2),
              ]),
            ]),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("SCookieBanner"),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "content-wrap" }, [
      _c("div", { staticClass: "container policy-content" }, [
        _c("h1", { staticClass: "ppmountent text-main-color policy-title" }, [
          _vm._v("Política de Privacidad"),
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "text-dark-grey-color" }, [
          _vm._v(
            "\n            De conformidad a lo dispuesto en el Reglamento (UE) 2016/679 del Parlamento Europeo y del Consejo, de 27 de abril de 2016,\n            relativo a la protección de las personas físicas en lo que respecta al tratamiento de datos personales y a la libre circulación\n            de estos datos (RGPD), así como en cumplimiento de lo previsto en la Ley Orgánica 3/2018, de 5 de diciembre, de Protección de\n            Datos Personales y garantía de los derechos digitales (LOPDGDD), se informa a continuación sobre los siguientes puntos\n            relacionados con el tratamiento de datos de carácter personal que el Usuario facilite voluntariamente al acceder al Sitio Web\n            "
          ),
          _c("a", { attrs: { href: "https://platform.stemdo.io/" } }, [
            _vm._v("https://platform.stemdo.io/"),
          ]),
          _vm._v(
            '\n            (en adelante, el "Sitio Web" o "Web", indistintamente).\n          '
          ),
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "text-dark-grey-color" }, [
          _vm._v(
            "\n            En STEMDO ECOSYSTEM S.L., entidad responsable del tratamiento de los datos personales recabados a través de este Sitio Web,\n            nos comprometemos a asegurar que su información personal se encuentre protegida y no se utilice de forma indebida.\n          "
          ),
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "text-dark-grey-color" }, [
          _vm._v(
            "\n            La presente Política de Privacidad se aplica al tratamiento de datos a través del Sitio Web realizados en el marco de las\n            actividades del grupo STEMDO. No obstante, el responsable del tratamiento de los datos personales será en todo caso\n            STEMDO ECOSYSTEM S.L.\n          "
          ),
        ]),
        _vm._v(" "),
        _c("h2", [
          _vm._v(
            "¿Quién es el responsable del tratamiento de los datos del Usuario?"
          ),
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "text-dark-grey-color" }, [
          _vm._v(
            "\n            STEMDO ECOSYSTEM S.L. forma parte del grupo STEMDO, integrado por distintas sociedades que operan bajo dicha denominación.\n            A efectos de la normativa de protección de datos, STEMDO ECOSYSTEM S.L. es la única entidad responsable del tratamiento de\n            los datos personales recabados a través de este Sitio Web.\n          "
          ),
        ]),
        _vm._v(" "),
        _c("ul", { staticClass: "text-dark-grey-color" }, [
          _c("li", [_c("strong", [_vm._v("CIF:")]), _vm._v(" B10862423")]),
          _vm._v(" "),
          _c("li", [
            _c("strong", [_vm._v("Domicilio:")]),
            _vm._v(
              " Calle de la Villa de Madrid 17 - Despacho 15, 21001 Huelva"
            ),
          ]),
          _vm._v(" "),
          _c("li", [_c("strong", [_vm._v("Teléfono:")]), _vm._v(" 959469471")]),
          _vm._v(" "),
          _c("li", [
            _c("strong", [_vm._v("Correo electrónico DPD:")]),
            _vm._v(" "),
            _c("a", { attrs: { href: "mailto:dpd@stemdo.io" } }, [
              _vm._v("dpd@stemdo.io"),
            ]),
          ]),
          _vm._v(" "),
          _c("li", [
            _c("strong", [_vm._v("Datos de Registro:")]),
            _vm._v(
              " Registro Mercantil de Huelva, Hoja H-27602, Tomo 1187, Folio 139"
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "text-dark-grey-color" }, [
          _vm._v(
            "\n            STEMDO ECOSYSTEM S.L. tratará los datos personales proporcionados voluntariamente por el usuario al acceder a la Web.\n            El Usuario consiente expresamente que STEMDO pueda tratar esos datos en los términos establecidos en esta Política de\n            Privacidad. Antes de registrarse en el Sitio Web, el Usuario debe leer y aceptar la presente Política de Privacidad y\n            Protección de Datos.\n          "
          ),
        ]),
        _vm._v(" "),
        _c("h2", [_vm._v("¿Qué información tratamos?")]),
        _vm._v(" "),
        _c("p", { staticClass: "text-dark-grey-color" }, [
          _vm._v(
            "\n            El tipo de información que recopilemos dependerá de las circunstancias y de los servicios que utilice el Usuario.\n            En términos generales, obtendremos información del Usuario de la siguiente manera:\n          "
          ),
        ]),
        _vm._v(" "),
        _c("ul", { staticClass: "text-dark-grey-color" }, [
          _c("li", [
            _c("strong", [_vm._v("Datos identificativos y de contacto:")]),
            _vm._v(
              " obtenemos los datos identificativos y de contacto del Usuario\n              cuando contrata nuestros servicios, solicita información, envía una consulta o solicita colaborar con nosotros.\n            "
            ),
          ]),
          _vm._v(" "),
          _c("li", [
            _c("strong", [_vm._v("Datos de navegación y uso del Sitio Web")]),
            _vm._v(
              ' (cookies, IP, comportamiento de navegación): obtenemos\n              información sobre cómo utiliza nuestra web. Podríamos utilizar esta información para ofrecer contenidos de interés\n              y contribuir a nuestra estrategia de marketing mediante técnicas de "perfilado". El Usuario podrá oponerse a dicho\n              tratamiento en cualquier momento.\n            '
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("h2", [
          _vm._v(
            "¿Con qué finalidad recabamos la información personal del Usuario?"
          ),
        ]),
        _vm._v(" "),
        _c("ul", { staticClass: "text-dark-grey-color" }, [
          _c("li", [_vm._v("Cumplimiento de obligaciones legales.")]),
          _vm._v(" "),
          _c("li", [
            _vm._v(
              "Prestación de servicios y/o gestión de la contratación de servicios ofrecidos por el grupo STEMDO."
            ),
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v(
              "Canalizar las solicitudes de información, sugerencias y reclamaciones para su gestión y resolución."
            ),
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v(
              "Mantener al Usuario informado sobre nuestros servicios, eventos y vacantes, en caso de que el Usuario preste su consentimiento."
            ),
          ]),
          _vm._v(" "),
          _c("li", [_vm._v("Gestión de selección de personal.")]),
        ]),
        _vm._v(" "),
        _c("h2", [
          _vm._v(
            "¿Cuál es la legitimación para el tratamiento de los datos del Usuario?"
          ),
        ]),
        _vm._v(" "),
        _c("ul", { staticClass: "text-dark-grey-color" }, [
          _c("li", [
            _vm._v(
              "La ejecución de un contrato y/o el mantenimiento de una relación comercial con el Usuario."
            ),
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v(
              "El cumplimiento de obligaciones legales aplicables al responsable del tratamiento."
            ),
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v(
              "\n              El interés legítimo del responsable del tratamiento, en particular para: la gestión de la seguridad de la información\n              y la ciberseguridad, la detección y prevención de accesos no autorizados, el registro y control de accesos a sistemas,\n              la realización de acciones de marketing directo a clientes existentes y la mejora continua de los servicios.\n            "
            ),
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v(
              "El consentimiento del Usuario, para el envío de comunicaciones comerciales relativas a servicios, eventos, ofertas de empleo u otras informaciones de interés."
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("h2", [
          _vm._v("¿A qué destinatarios se comunicarán los datos del Usuario?"),
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "text-dark-grey-color" }, [
          _vm._v(
            "\n            Los datos personales del Usuario no se comunicarán a terceros, salvo obligación legal o cuando resulte necesario para la\n            prestación del servicio solicitado. Cuando sea necesario, los datos podrán ser cedidos a las siguientes empresas del grupo STEMDO:\n          "
          ),
        ]),
        _vm._v(" "),
        _c("ul", { staticClass: "text-dark-grey-color" }, [
          _c("li", [_vm._v("STEMDO ASTREA, S.L.U.")]),
          _vm._v(" "),
          _c("li", [_vm._v("STEMDO DIANA, S.L.U.")]),
          _vm._v(" "),
          _c("li", [_vm._v("STEMDO EBORA, S.L.U.")]),
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "text-dark-grey-color" }, [
          _vm._v(
            "\n            En concreto se comunicarán a la Agencia Estatal de la Administración Tributaria y a bancos y entidades financieras para el\n            cobro del servicio prestado, así como a los encargados del tratamiento necesarios para la ejecución del acuerdo. Las\n            transferencias internacionales de datos, en su caso, se realizarán únicamente a entidades que hayan suscrito cláusulas\n            contractuales tipo (SCCs) conforme a la normativa europea vigente.\n          "
          ),
        ]),
        _vm._v(" "),
        _c("h2", [
          _vm._v(
            "¿Es obligatorio proporcionar toda la información solicitada?"
          ),
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "text-dark-grey-color" }, [
          _vm._v(
            '\n            En los formularios de la Página Web, el Usuario tiene que cumplimentar los campos marcados como "obligatorios". La falta de\n            comunicación de los datos personales obligatorios puede resultar en la imposibilidad de ofrecer el servicio solicitado.\n            Los datos personales facilitados deben ser actuales para que la información se mantenga actualizada y sin errores.\n          '
          ),
        ]),
        _vm._v(" "),
        _c("h2", [_vm._v("¿Tratamos datos de menores de edad?")]),
        _vm._v(" "),
        _c("p", { staticClass: "text-dark-grey-color" }, [
          _vm._v(
            "No tratamos datos de menores de 18 años. El Usuario debe abstenerse de facilitarlos si no tiene esa edad."
          ),
        ]),
        _vm._v(" "),
        _c("h2", [_vm._v("¿Qué medidas de seguridad aplicamos?")]),
        _vm._v(" "),
        _c("p", { staticClass: "text-dark-grey-color" }, [
          _vm._v(
            "\n            STEMDO ECOSYSTEM S.L. ha adoptado las medidas técnicas y organizativas necesarias para garantizar un nivel de seguridad\n            adecuado al riesgo, conforme a lo previsto en la normativa vigente en materia de protección de datos.\n          "
          ),
        ]),
        _vm._v(" "),
        _c("h2", [
          _vm._v(
            "¿Cuáles son los derechos del Usuario en relación con el tratamiento de datos?"
          ),
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "text-dark-grey-color" }, [
          _vm._v(
            "\n            El Reglamento General de Protección de Datos concede diversos derechos al Usuario respecto al tratamiento de sus datos personales:\n          "
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "policy-table-wrapper" }, [
          _c("table", { staticClass: "policy-table" }, [
            _c("thead", [
              _c("tr", [
                _c("th", [_vm._v("Derecho")]),
                _vm._v(" "),
                _c("th", [_vm._v("Descripción")]),
              ]),
            ]),
            _vm._v(" "),
            _c("tbody", [
              _c("tr", [
                _c("td", [_c("strong", [_vm._v("Supresión")])]),
                _vm._v(" "),
                _c("td", [
                  _vm._v(
                    "\n                    Derecho a solicitar la eliminación de sus datos personales cuando: ya no sean necesarios para los fines recopilados;\n                    retire su consentimiento; se oponga al tratamiento; o los datos hayan sido tratados de manera ilícita.\n                  "
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("td", [_c("strong", [_vm._v("Acceso")])]),
                _vm._v(" "),
                _c("td", [
                  _vm._v(
                    "\n                    Derecho a obtener confirmación acerca de si se están procesando datos personales y, en caso afirmativo, acceder a los\n                    propósitos del tratamiento, las categorías de datos, los destinatarios y el período previsto de conservación.\n                  "
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("td", [_c("strong", [_vm._v("Rectificación")])]),
                _vm._v(" "),
                _c("td", [
                  _vm._v(
                    "\n                    Derecho a corregir los datos personales inexactos o a completar los incompletos, adjuntando la documentación\n                    justificativa si fuera necesario.\n                  "
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("td", [_c("strong", [_vm._v("Limitación")])]),
                _vm._v(" "),
                _c("td", [
                  _vm._v(
                    "\n                    Derecho a solicitar la limitación del tratamiento mientras se verifica la exactitud de los datos, si el tratamiento\n                    es ilícito, si STEMDO ya no los necesita pero el Usuario los requiere para reclamaciones, o mientras se verifica si\n                    los motivos legítimos de STEMDO prevalecen sobre los del Usuario.\n                  "
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("td", [_c("strong", [_vm._v("Portabilidad")])]),
                _vm._v(" "),
                _c("td", [
                  _vm._v(
                    "\n                    Derecho a recibir los datos personales en un formato estructurado, de uso común y lectura mecánica, y a transmitirlos\n                    a otro responsable del tratamiento cuando sea técnicamente posible.\n                  "
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("td", [_c("strong", [_vm._v("Oposición")])]),
                _vm._v(" "),
                _c("td", [
                  _vm._v(
                    "\n                    Derecho a oponerse al tratamiento de sus datos personales, incluida la elaboración de perfiles, en cualquier momento,\n                    salvo que existan motivos legítimos imperiosos para continuar el tratamiento.\n                  "
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("td", [_c("strong", [_vm._v("Decisiones automatizadas")])]),
                _vm._v(" "),
                _c("td", [
                  _vm._v(
                    "\n                    Derecho a no ser objeto de una decisión basada únicamente en el tratamiento automatizado, incluida la elaboración de\n                    perfiles, que tenga efectos jurídicos o le afecte significativamente.\n                  "
                  ),
                ]),
              ]),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c("h3", [_vm._v("Canales para ejercer estos derechos")]),
        _vm._v(" "),
        _c("p", { staticClass: "text-dark-grey-color" }, [
          _vm._v(
            "\n            Para ejercer cualquiera de los derechos mencionados, el Usuario puede enviar un correo electrónico a\n            "
          ),
          _c("a", { attrs: { href: "mailto:dpd@stemdo.io" } }, [
            _vm._v("dpd@stemdo.io"),
          ]),
          _vm._v(
            " o una carta a la dirección indicada en el apartado primero.\n            El plazo máximo para resolver es de un mes desde la recepción de la solicitud.\n          "
          ),
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "text-dark-grey-color" }, [
          _vm._v(
            "\n            El Usuario tiene derecho a presentar una reclamación ante la "
          ),
          _c("strong", [_vm._v("Agencia Española de Protección de Datos")]),
          _vm._v(":\n          "),
        ]),
        _vm._v(" "),
        _c("ul", { staticClass: "text-dark-grey-color" }, [
          _c("li", [
            _c("strong", [_vm._v("Dirección postal:")]),
            _vm._v(" Calle Jorge Juan Nº 6, CP 28001, Madrid"),
          ]),
          _vm._v(" "),
          _c("li", [
            _c("strong", [_vm._v("Web:")]),
            _vm._v(" "),
            _c(
              "a",
              { attrs: { href: "https://www.aepd.es", target: "_blank" } },
              [_vm._v("www.aepd.es")]
            ),
          ]),
          _vm._v(" "),
          _c("li", [
            _c("strong", [_vm._v("Teléfonos:")]),
            _vm._v(" 901 100 099 / 91 266 35 17"),
          ]),
        ]),
        _vm._v(" "),
        _c("h2", [
          _vm._v(
            "¿Durante cuánto tiempo vamos a mantener los datos personales del Usuario?"
          ),
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "text-dark-grey-color" }, [
          _vm._v(
            "\n            Los datos personales serán mantenidos mientras el Usuario mantenga una relación con STEMDO ECOSYSTEM S.L. Una vez se\n            desvincule, los datos se mantendrán durante los plazos legalmente previstos, incluido el plazo en el que un juez o tribunal\n            los pueda requerir. STEMDO ECOSYSTEM S.L. mantendrá toda la información relativa a la prestación del servicio mientras\n            duren las garantías de los productos o servicios.\n          "
          ),
        ]),
        _vm._v(" "),
        _c("h2", [_vm._v("Decisiones automatizadas")]),
        _vm._v(" "),
        _c("p", { staticClass: "text-dark-grey-color" }, [
          _vm._v(
            "\n            No se adoptan decisiones automatizadas con efectos jurídicos. En caso de elaborarse perfiles, se basarán en datos de\n            navegación con la finalidad de personalización de contenidos y mejora de la experiencia del Usuario, sin efectos legales.\n          "
          ),
        ]),
        _vm._v(" "),
        _c("h2", [_vm._v("Exactitud de los datos")]),
        _vm._v(" "),
        _c("p", { staticClass: "text-dark-grey-color" }, [
          _vm._v(
            "El Usuario garantiza que los datos facilitados son exactos y actualizados."
          ),
        ]),
        _vm._v(" "),
        _c("h2", [_vm._v("Cambios en la presente Política de Privacidad")]),
        _vm._v(" "),
        _c("p", { staticClass: "text-dark-grey-color" }, [
          _vm._v(
            "\n            STEMDO ECOSYSTEM S.L. se reserva el derecho de modificar la presente Política de Privacidad para adecuarla a novedades\n            legislativas, jurisprudenciales o prácticas de la industria. En tales casos, STEMDO ECOSYSTEM S.L. comunicará los cambios\n            realizados en esta página con una antelación razonable antes de que entren en vigor.\n          "
          ),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c(
      "div",
      {
        staticClass: "col-md-3 text-center text-md-start",
        staticStyle: { color: "#606061" },
      },
      [_c("b", [_vm._v("Stemdo © 2024")])]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c(
      "div",
      { staticClass: "col-md-2 text-center text-md-end pb-4 pb-sm-0" },
      [
        _c("div", { staticClass: "d-flex justify-content-around" }, [
          _c(
            "a",
            {
              attrs: {
                href: "https://www.instagram.com/stemdo_io/?hl=es",
                target: "_blank",
              },
            },
            [
              _c("img", {
                staticClass: "logo-default",
                attrs: {
                  src: "/content/images/instagram-icon.png",
                  alt: "Instagram icon",
                },
              }),
            ]
          ),
          _vm._v(" "),
          _c(
            "a",
            {
              attrs: {
                href: "https://www.linkedin.com/company/stemdo/",
                target: "_blank",
              },
            },
            [
              _c("img", {
                staticClass: "logo-default",
                attrs: {
                  src: "/content/images/linkedin-icon.png",
                  alt: "Linkedin icon",
                },
              }),
            ]
          ),
        ]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }